/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Options_PageInputs */

const en_svchip_options_page = /** @type {(inputs: Svchip_Options_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options page`)
};

const ar_svchip_options_page = /** @type {(inputs: Svchip_Options_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صفحة الخيارات`)
};

const bn_svchip_options_page = /** @type {(inputs: Svchip_Options_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অপশন পেজ`)
};

const de_svchip_options_page = /** @type {(inputs: Svchip_Options_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionsseite`)
};

const es_svchip_options_page = /** @type {(inputs: Svchip_Options_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página de opciones`)
};

const fr_svchip_options_page = /** @type {(inputs: Svchip_Options_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page d'options`)
};

const pt_svchip_options_page = /** @type {(inputs: Svchip_Options_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página de opções`)
};

const zh_svchip_options_page = /** @type {(inputs: Svchip_Options_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选项页面`)
};

const tr_svchip_options_page = /** @type {(inputs: Svchip_Options_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seçenekler sayfası`)
};

const ru_svchip_options_page = /** @type {(inputs: Svchip_Options_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница параметров`)
};

const pl_svchip_options_page = /** @type {(inputs: Svchip_Options_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona opcji`)
};

/**
* | output |
* | --- |
* | "Options page" |
*
* @param {Svchip_Options_PageInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_options_page = /** @type {((inputs?: Svchip_Options_PageInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Options_PageInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_options_page(inputs)
	if (locale === "bn") return bn_svchip_options_page(inputs)
	if (locale === "de") return de_svchip_options_page(inputs)
	if (locale === "es") return es_svchip_options_page(inputs)
	if (locale === "fr") return fr_svchip_options_page(inputs)
	if (locale === "pt") return pt_svchip_options_page(inputs)
	if (locale === "zh") return zh_svchip_options_page(inputs)
	if (locale === "tr") return tr_svchip_options_page(inputs)
	if (locale === "ru") return ru_svchip_options_page(inputs)
	if (locale === "pl") return pl_svchip_options_page(inputs)
	return en_svchip_options_page(inputs)
});